import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    Paper,
} from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAppTheme } from '../themes/ThemeContext';

const ContactUs: React.FC = () => {
    const { mode } = useAppTheme();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // You can connect this to your API or email service
        alert('Message sent! (Simulation)');
    };

    return (
        <Box
            className="d-flex flex-column min-vh-100"
            sx={{
                bgcolor: mode === 'dark' ? '#1c1c1c' : '#f5f5f5',
                color: mode === 'dark' ? '#f5f5f5' : '#111',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
        >


            <Container maxWidth="sm" sx={{ mt: 12, mb: 4, flex: 1 }}>
                <Typography variant="h5" align="center" sx={{ mb: 2 }}>
                    We'd love to hear from you.
                </Typography>

                <Paper elevation={3} sx={{ p: 4 }}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Contact Us
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <TextField
                                label="Name"
                                variant="outlined"
                                fullWidth
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField
                                label="Email"
                                type="email"
                                variant="outlined"
                                fullWidth
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <TextField
                                label="Message"
                                variant="outlined"
                                multiline
                                rows={5}
                                fullWidth
                                required
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                            <Button type="submit" variant="contained" color="primary" fullWidth>
                                Send Message
                            </Button>
                        </Box>
                    </form>
                </Paper>
            </Container>

        </Box>
    );
};

export default ContactUs;
